import React, { Fragment, useState, useEffect } from 'react';
import TableBuilder, { ApiRequest } from '../../../GlobalComponents/Builders';
import { Container, Row, Card, CardBody } from 'reactstrap'
import moment from 'moment';

const AuditLog = () => {

    const [isProcessing, setIsProcessing] = useState(true);
    const [auditData, setAuditData] = useState([]);

    useEffect(() => {

        document.title = 'View Audit Log'

        ApiRequest('GET', '/audit/logs', { setIsProcessing })
            .then((res) => {
                setAuditData(res.success && Array.isArray(res.data) ? res.data : [])
            })
    }, []);

    // Prefer the enriched fields from the improved v_audit, with fallbacks to
    // the legacy shape so the view still works before the view migration ships.
    const userName = (row) => row.user_name || [row.first_name, row.last_name].filter(Boolean).join(' ') || '-';
    const whenText = (row) => row.audit_datetime
        ? moment(row.audit_datetime).format('LLL')
        : (row.audit_time ? moment.unix(row.audit_time).format('LLL') : '-');

    return (
            <Fragment>
                <Row>
                    <Container>
                        <Card>
                        <CardBody>
                            <TableBuilder
                                data={auditData}
                                title='Audit Log'
                                sortField={null}
                                subHeader={true}
                                processing={isProcessing}
                                columnsToSearch={[
                                    'user_name', 'first_name', 'last_name', 'email',
                                    'partner_name', 'request_url', 'action', 'method',
                                    'request_status', 'status_code', 'ip_address',
                                ]}
                                columns = {[
                                    {
                                        name: 'Name',
                                        selector: (row) => userName(row),
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Email',
                                        selector: (row) => row.email || '-',
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Partner',
                                        selector: (row) => row.partner_name || '-',
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Page',
                                        selector: (row) => row.request_url || '-',
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Action',
                                        selector: (row) => row.action || '-',
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Status',
                                        selector: (row) => row.request_status || row.status_code || '-',
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'IP Address',
                                        selector: (row) => row.ip_address || '-',
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Time',
                                        selector: (row) => whenText(row),
                                        sortable: true,
                                        center: true,
                                    }
                                ]}
                            />
                        </CardBody>
                        </Card>
                    </Container>
                </Row>
            </Fragment>
    );
};

export default AuditLog;
